import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { FileUploadFileSizeValidatorValue } from '../../../types/validator.types';
import { ValidatorEditorBase } from '../validator-editor-base/validator-editor-base';

@Component({
  selector: 'df-file-upload-file-size-validator-editor',
  templateUrl: './file-upload-file-size-validator-editor.component.html',
  styleUrls: ['./file-upload-file-size-validator-editor.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileUploadFileSizeValidatorEditorComponent extends ValidatorEditorBase<FileUploadFileSizeValidatorValue>
  implements OnInit {
  ngOnInit() {
    if (!this.caption) {
      this.caption = 'éå¶æä»¶ä¸ä¼ å¤§å°';
    }
  }

  defaultModelData(): FileUploadFileSizeValidatorValue {
    return { size: undefined };
  }
}
